import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  Slide,
} from '@mui/material'
import React from 'react'
import styles from './base-modal.module.scss'
import { TransitionProps } from '@mui/material/transitions'

export interface ModalProps {
  isOpen: boolean
  onClose: () => void
  modalClassName?: string
}

export interface BaseModalProps
  extends ModalProps,
    Omit<DialogProps, 'onClose' | 'open' | 'content'> {
  closeIcon?: boolean
  fullWidth?: boolean
  actions?: React.ReactNode[] | React.ReactNode
  verticalActions?: boolean
  isSquare?: boolean
  actionsClassName?: string
  isTransparent?: boolean
  paperClassName?: string
  modalTitle?: string | React.ReactElement
  modalWrapperClassName?: string
  modalTitleClassName?: string
  disableEnforceFocus?: boolean
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
  actions,
  modalClassName,
  closeIcon = true,
  verticalActions = false,
  isSquare = false,
  isTransparent = false,
  fullWidth = true,
  PaperProps,
  actionsClassName,
  modalWrapperClassName,
  modalTitle,
  paperClassName,
  modalTitleClassName,
  disableEnforceFocus = false,
  children,
  ...props
}) => {
  return (
    <Dialog
      {...props}
      className={modalClassName}
      open={isOpen}
      TransitionComponent={Transition}
      onClose={onClose}
      PaperProps={PaperProps}
      keepMounted
      fullWidth={fullWidth}
      disableEnforceFocus={disableEnforceFocus}
    >
      <DialogContent className={styles.content}>{children}</DialogContent>
      <DialogActions disableSpacing={verticalActions}>{actions}</DialogActions>
    </Dialog>
  )
}
